import { createContext } from 'react'
import type { Feature, Role } from '@/enum/global.enum'
import type { LucideIcon } from 'lucide-react'

/** A sidebar entry at any depth. Groups nest further entries in `items`. */
export interface SearchableNavItem {
  title: string
  url: string
  activeUrls?: string[]
  icon?: LucideIcon
  role?: Role[]
  feature?: Feature
  items?: SearchableNavItem[]
}

export interface SearchableMenuItem extends SearchableNavItem {
  hidden?: boolean
  isActive?: boolean
}

export interface SearchableOtherItem {
  name: string
  url: string
  icon: LucideIcon
  role?: Role[]
  feature?: Feature
}

interface SidebarSearchContextType {
  searchQuery: string
  setSearchQuery: (query: string) => void
  filterMenuItems: (items: SearchableMenuItem[]) => SearchableMenuItem[]
  filterOtherItems: (items: SearchableOtherItem[]) => SearchableOtherItem[]
  clearSearch: () => void
  hasSearchResults: (menuItems: SearchableMenuItem[], otherItems: SearchableOtherItem[]) => boolean
  isSearching: boolean
}

export const SidebarSearchContext = createContext<SidebarSearchContextType | undefined>(undefined)
